/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingProgramDepartmentDto
 */
export interface TrainingProgramDepartmentDto {
    /**
     * 
     * @type {number}
     * @memberof TrainingProgramDepartmentDto
     */
    department: number;
    /**
     * 
     * @type {string}
     * @memberof TrainingProgramDepartmentDto
     */
    departmentName: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof TrainingProgramDepartmentDto
     */
    positions: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrainingProgramDepartmentDto
     */
    positionNames: Array<string>;
}

export function TrainingProgramDepartmentDtoFromJSON(json: any): TrainingProgramDepartmentDto {
    return {
        'department': json['department'],
        'departmentName': json['departmentName'],
        'positions': json['positions'],
        'positionNames': json['positionNames'],
    };
}

export function TrainingProgramDepartmentDtoToJSON(value?: TrainingProgramDepartmentDto | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'department': value.department,
        'departmentName': value.departmentName,
        'positions': value.positions,
        'positionNames': value.positionNames,
    };
}


